import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import React, { Fragment, useEffect, useState } from "react";
import { requestResetPassword } from "../../../api/user.api";
import { success } from "../../../utils/notifications";
const initialData = {
  email: "",
};
const ForgotPassword = ({ open, setOpen }) => {
  const [forgotPassword, setForgotPassword] = useState(initialData);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForgotPassword({
      ...forgotPassword,
      [name]: value,
    });
  };

  // const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Email sent", forgotPassword);
    try {
      await requestResetPassword(forgotPassword.email);
      setForgotPassword(initialData);
      setOpen(false);
success("Email sent SuccessFully", "Check your email and click on the 'Forgot Password' button to reset your password"); 

    } catch (error) {
      console.error("Error logging in:", error);
    }
  };
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="z-50" onClose={setOpen}>
        <Transition.Child
          enter="ease-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-300"
          leaveFrom="opacity-100 transform scale-100"
          leaveTo="opacity-0 transform scale-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="w-full fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-500"
              enterFrom="opacity-0 transform scale-0"
              enterTo="opacity-100 transform scale-100"
              leave="ease-in duration-300"
              leaveFrom="opacity-100 transform scale-100"
              leaveTo="opacity-0 transform scale-0"
            >
              <Dialog.Panel className="mt-12 z-50 fixed mx-auto rounded-lg bg-white pt-5 pb-4 text-left shadow-xl transition-all">
                <div className="absolute top-0 right-0 pt-4 pr-4 sm:block">
                  <button
                    type="button"
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                    onClick={() => setOpen(false)}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>
                <div className="lg:w-[35rem] md:w-[30rem] w-[22rem]">
                  <div className=" sm:text-left">
                    <Dialog.Title
                      as="h3"
                      className="px-3 pb-5 text-xl font-medium border-b-2 border-gray-200 leading-6 text-gray-700"
                    >
                      Forgot Password
                    </Dialog.Title>
                    <div className="">
                      <form onSubmit={handleSubmit} method="POST">
                        <div className="">
                          <div className="px-7 py-4">
                            <div className="py-3 ">
                              <div className="py-0.5 items-center grid grid-cols-12">
                                <div className="lg:col-span-12 md:col-span-12 col-span-12 ">
                                  <h1 className="text-lg font-semibold text-gray-600 mb-7">
                                    Enter your email address and we'll send you
                                    a link to reset your password.
                                  </h1>
                                  <label
                                    htmlFor="email"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Email
                                  </label>
                                </div>
                                <div className="lg:col-span-12 md:col-span-12 col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="email"
                                      name="email"
                                      placeholder="Enter Email"
                                      value={forgotPassword.email}
                                      onChange={handleChange}
                                      id="email"
                                      className="text-sm font-medium bg-neutral-100 bg-opacity-80 px-3 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-300 border-2 border-transparent focus:border-2 focus:border-yellow sm:leading-6"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="border-t-2 border-gray-200 px-7 pt-3 flex items-center justify-end">
                          <button
                            type="submit"
                            className="flex justify-center rounded-md bg-yellow px-3 py-2.5 px-10 text-base font-semibold leading-6 text-dark shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow"
                          >
                            Send Email
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default ForgotPassword;
